import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Left Column - Brand */}
          <div>
            <h3 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              OverUnder Roofing
            </h3>
            <p className="text-lg italic text-gray-400 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              The House Always Wins
            </p>
            <p className="text-sm text-gray-400 leading-relaxed mb-8">
              Your independent roofing advocate serving Wake County and the Triangle area (Raleigh, Cary, Apex, Wake Forest, Holly Springs, Fuquay-Varina, Garner, and surrounding communities). We help homeowners get transparent, competitive bids without the pressure or commission conflicts.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-emerald-500 hover:text-emerald-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-emerald-500 hover:text-emerald-500 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-emerald-500 hover:text-emerald-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-emerald-500 hover:text-emerald-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('benefits')} className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  Benefits
                </button>
              </li>
              <li>
                <Link to="/wake-county-simulation" className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  Market Data
                </Link>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  FAQ
                </button>
              </li>
              <li>
                <Link to="/resources" className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/overunder-method" className="text-base text-white hover:text-emerald-400 hover:underline transition-colors cursor-pointer">
                  The OverUnder Method
                </Link>
              </li>
            </ul>
          </div>

          {/* Right Column - Contact & Legal */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">Contact</h4>
            <ul className="space-y-3 mb-8">
              <li>
                <a href="tel:+19193497701" className="text-xl text-white hover:text-emerald-400 transition-colors cursor-pointer">
                  (919) 349-7701
                </a>
              </li>
              <li>
                <a href="mailto:overunderroofing@gmail.com" className="text-base text-white hover:text-emerald-400 transition-colors cursor-pointer">
                  overunderroofing@gmail.com
                </a>
              </li>
              <li className="text-sm text-gray-400">
                2474 Walnut Street #214<br />
                Cary, NC 27518
              </li>
            </ul>

            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">Legal</h4>
            <p className="text-xs text-gray-500 italic leading-relaxed">
              OverUnder Roofing is not a licensed contractor. We provide independent advocacy and bid coordination services. All work performed by licensed NC contractors.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2025 OverUnder Roofing. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-400">
            <Link to="/privacy" className="hover:text-emerald-400 transition-colors cursor-pointer">Privacy Policy</Link>
            <span>|</span>
            <Link to="/terms" className="hover:text-emerald-400 transition-colors cursor-pointer">Terms of Service</Link>
            <span>|</span>
            <Link to="/accessibility" className="hover:text-emerald-400 transition-colors cursor-pointer">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}